export default "__VITE_ASSET__CrYC_mjP__"